import { PinnedTokens } from '../libs/portfolio/interfaces'

// Rules:
// 1. Pinned gas tank tokens with the same address are shared between networks. This means
// that if ETH is pinned on Ethereum and onGasTank is true, the same token shouldn't be
// onGasTank on Optimism.
// 2. Addresses must be checksummed.
export const PINNED_TOKENS: PinnedTokens = [
  // PulseChain (369): PLS, WPLS, PCOCK, USDC
  {
    chainId: 369n,
    address: '0x0000000000000000000000000000000000000000',
    onGasTank: false
  },
  {
    chainId: 369n,
    address: '0xA1077a294dDE1B09bB078844df40758a5D0f9a27',
    onGasTank: false
  },
  {
    chainId: 369n,
    address: '0xc10A4Ed9b4042222d69ff0B374eddd47ed90fC1F',
    onGasTank: false
  },
  {
    chainId: 369n,
    address: '0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07',
    onGasTank: false
  },
  // Ethereum (1): PCOCK
  {
    chainId: 1n,
    address: '0x088a72024995D9858F2Fbf6529D24cA9E7954bbd',
    onGasTank: false
  },
  // BNB Chain (56): PCOCK
  {
    chainId: 56n,
    address: '0x716728eBa47018AE5085B96895e293f114996702',
    onGasTank: false
  }
]
